import React, {Component} from "react";
import { Row, Col, Button, FormGroup, Label, Input } from "reactstrap";
import { inject, observer } from "mobx-react";
import FormInput from "../../../../comum/components/FormInput";
import Card from "../../../../comum/components/Card";
import FormSelect from "../../../../comum/components/FormSelect";
import { IconeDelete } from "../../../../comum/components/Icones";
import RetiradaDryStore from './../stores/RetiradaDepotDryStore';
import RadiobuttonGroup from '../../../../comum/components/RadiobuttonGroup';

@inject("store")
@observer
export class RetiradaDepotDryForm extends Component {
    constructor(props) {
        super(props);
        this.parametrosStore = this.props.store.parametrosStore;
        
        this.agendamentoController = this.props.agendamentoController;
        this.controller = new RetiradaDryStore();
    };

    componentDidMount() {     
        this.agendamentoController.isDepot = true;    
        if (!this.agendamentoController.isEditar){
            this.agendamentoController.adicionarRetirada();
        } else {
            if(this.agendamentoController.dadosAgendamento.listaBookings
                && this.agendamentoController.dadosAgendamento.listaBookings.length > 0
                && this.agendamentoController.dadosAgendamento.listaBookings[0].containers){

                this.agendamentoController.dadosAgendamento.listaBookings[0].containers.map((cntr, x) => {
                    this.controller.carregarDadosBooking(cntr.NumBooking ? cntr.NumBooking : "", x, this.agendamentoController.dadosAgendamento, false)
                    this.controller.carregarTiposCntrPorBooking(cntr.NumBooking ? cntr.NumBooking : "", x, this.agendamentoController.dadosAgendamento, false)})
            }
        }
    };

    botaoAdicionar(titulo) {
        return <Button onClick={ this.handleAdicionarClick } className="btn-com-bordas-primary">{titulo}</Button>;
    };

    handleAdicionarClick = () => {
        this.agendamentoController.adicionarRetiradaDepot(); 
        this.controller.adicionaNovoItemRetirada();
    }

    handleRemoverClick = (index) => {
        this.agendamentoController.removerRetiradaDepot(index);
        this.controller.removerItemRetirada(index);
    }

    campoQuantidade(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput   titulo="Quantidade" xs={12} sm={12} md={md} type="number"
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => {
                                if(event.target.value > this.controller.saldo[index]) {
                                    this.agendamentoController.listaMensagens = ["Quantidade maior do que permitida. O booking possui um saldo " + this.controller.saldo[index]];
                                    event.target.value = "";
                                }else {
                                    this.agendamentoController.setDadosAgendamento(dado, event) ;
                                }                                
                            }}
                />;
    };

    campoBooking(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  sm={12} xs={12} md={md} titulo="Booking"
                            bloqueado={ false }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.handleChangeBooking(dado, event, index, this.agendamentoController.dadosAgendamento) }  
                />;
    };

    campoArmador(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Armador"
                            bloqueado={ true }
                            value={ this.controller.armador[index] ? this.controller.armador[index].ApelidoArmador : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                />;
    };

    campoOperacao(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Operação"
                            bloqueado={ true }
                            value={ this.controller.operacao[index] ? this.controller.operacao[index].NavioViagem : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                />;
    };

    campoPod(md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Porto de Descarga"
                            bloqueado={ true }
                            value={ this.controller.pod[index] ? this.controller.pod[index].DescPortoOrig : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                />;
    };

    campoDestino(md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Destino Final"
                            bloqueado={ true }
                            value={ this.controller.destino[index] ? this.controller.destino[index].DescPortoDest : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                />;
    };

    campoTipoCntr(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormSelect  xs={12} sm={12} md={md} titulo="Tipo"        
                            bloqueado={ false }
                            itens={ this.controller.tiposCntr[index] }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            itensValor="CodTipoCntr" itensLabel="CodTipoCntr"
                            onChange={ (event) => this.handleChangeTipoCntr(dado, event, index) } 
                />;
    };

    campoPayload(md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Payload / MGW"
                            bloqueado={ true }
                            value={ this.controller.destino[index] ? this.controller.destino[index].PayloadMgw : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                />;
    };

    handleChangeBooking = (dado, event, index, dadosAgendamento) => {
        this.controller.carregarDadosBooking(event && event.target ? event.target.value : "", index, dadosAgendamento, this.agendamentoController);
        this.controller.carregarTiposCntrPorBooking(event && event.target ? event.target.value : "", index, dadosAgendamento);
        this.agendamentoController.setDadosAgendamento(dado, event);
        
        this.agendamentoController.atualizaRetiradas = false;
        setTimeout(function () {
            this.agendamentoController.atualizaRetiradas = true;
        }.bind(this), 1)
    };

    handleChangeTipoCntr = (dado, event, index) => {
        let item = this.controller.tiposCntr[index].filter(item => item.CodTipoCntr === event.value);

        if("N" !== item[0].FlgRefrigCntr){
            this.agendamentoController.listaMensagens = ["Agendamento somente permitido para Dry. Por favor, selecione um Tipo compatível."];
        } else {
            //this.controller.qtdDisponivel[index] = item[0].Quantidade;
            //this.controller.isReefer[index] = "S" === item[0].FlgRefrigCntr;
            //this.controller.carregarDadosTipoCntr(item[0].BookingCntrId, index);
            this.agendamentoController.setDadosAgendamento(dado, event);
        }        
        
        this.agendamentoController.atualizaRetiradas = false;
        setTimeout(function () {
            this.agendamentoController.atualizaRetiradas = true;
        }.bind(this), 1)
    };
    
    campoQuantidadeDisponivel(md, index) {
        return <Col xs={12} sm={12} md={md}>
            <FormGroup>
                <Label>Qtd Disponível</Label>
                <Input defaultValue={ this.controller.qtdDisponivel[index] }
                    disabled = {true} />
            </FormGroup>
        </Col>;
    };

    cardVazioImp(titulo) {
       
            return <div>
                <Row>
                    <Col>
                        <h2>{ titulo }</h2>
                    </Col>
                    { !this.agendamentoController.isEditar && this.botaoAdicionar("Novo") }                    
                </Row>
                <Row>
                    { 
                     this.agendamentoController.dadosAgendamento.listaBookings
                        && this.agendamentoController.dadosAgendamento.listaBookings.length > 0
                        && this.agendamentoController.dadosAgendamento.listaBookings[0].containers
                        && this.agendamentoController.dadosAgendamento.listaBookings[0].containers.map((cntr, x) =>
                            <Col className="area-form card-form" xl={12} key={x}>
                                <Card>
                                    <Row>
                                        { this.campoBooking(`listaBookings[0].containers[${x}].NumBooking`, 4, x) }
                                        { this.campoArmador(`listaBookings[0].containers[${x}].ArmIdDepot`, 4, x) }
                                        { this.campoOperacao(`listaBookings[0].containers[${x}].VesselvisitId`, 4, x) }
                                        { this.campoTipoCntr(`listaBookings[0].containers[${x}].CdTipoCntr`, 3, x) }
                                        { this.campoPayload(3, x) }
                                        { this.campoPod(3, x) }
                                        { this.campoDestino( 3, x) }
                                        { this.campoQuantidade(`listaBookings[0].containers[${x}].QtdRetirada`, 4, x) }
                                    </Row>
                                </Card>
                                { !this.agendamentoController.isEditar
                                    && <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () =>  this.handleRemoverClick(x) } /> }
                            </Col>
                    )}
                </Row>                
            </div>
    };

    

    formDepot() {
        switch (this.props.tipoAgenda) {
            case "DRED":
                return this.cardVazioImp("Depot - Retirada Exportação Dry")
            default:
                break;
        }
    };

    render() {
        return (
            <div>
                { (this.agendamentoController.terminal === "SSA") && this.formDepot() }
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers-dry/components/RetiradaDepotDryForm.js